export default {
  en_US: {
    twitter: 'X',
    facebook: 'Facebook',
    telegram: 'Telegram',
    whatsapp: 'WhatsApp',
    google: 'Google',
    perform_app_not_installed: '%1$s App not installed',
    about_us: 'About us',
    no_data_available: 'No data available',
    register: 'Register',
    close: 'Close',
    phone_number_or_email: 'Email',
    password: 'Password',
    other_methods: 'Other methods',
    forgot_password: 'Forgot password',
    login: 'Login',
    check_for_updates: 'Check for updates',
    security_verification: 'Security Verification',
    phone_verificate: 'Phone verification',
    email_verificate: 'Email verification',
    google_verificate: 'Google verification',
    google_verification_code: 'Google Verification Code',
    phone_verification_code: 'Phone Verification Code',
    email_verification_code: 'Email Verification Code',
    login_tip_didSendCode: 'Verification code sent',
    register_action_setPassword: 'Set your password',
    register_tip_repeatPassword: 'Enter password again',
    login_action_resetPassword: 'Reset password',
    toast_google_code_missing: 'Enter Google verification code',
    toast_phone_code_missing: 'Enter phone verification code',
    toast_email_code_missing: 'Enter email verification code',
    verification_methods_required: 'All verification methods must be approved',
    id_card_number: 'Identification Document Number',
    input_national_id: 'Enter your national ID',
    google_code: 'Google code',
    next: 'Next',
    settings: 'Settings',
    deposit: 'Receive',
    deposit_qr_code_tip: 'This address can only receive %1$s network assets',
    save_qr_code: 'Save QR code',
    deposit_network: 'Network',
    deposit_asset: 'Receive %1$s',
    deposit_address: 'Address',
    copy: 'Copy',
    how_to_deposit: 'How to Deposit?',
    language: 'Language',
    search: 'Search contract',
    search_currency: 'Search contract',
    choose_country_or_area: 'Country/area:',
    country_saudi_arabia: 'Saudi Arabia',
    select_country_area: 'Your country/area',
    email: 'Email',
    default_area_saudi_arabia: 'SAUDI ARABIA (+966)',
    default_country_code: '+966',
    referral_id_hint_optional: 'Invite Code (Optional)',
    referral_id_hint: 'Invite Code',
    settings_kline_color: 'Up/Down color',
    invite_friend: 'Referral',
    version: 'Version',
    logout: 'Logout',
    settings_global_kline_color: 'Green for rising and red for falling',
    settings_china_kline_color: 'Red for rising and green for falling',
    home: 'Home',
    markets: 'Markets',
    wallets: 'Funds',
    trades: 'Trade',
    save_success: 'Saved',
    save_fail: 'Save Failed',
    storage_permission_warning: 'No Storage Permission',
    select_currency: 'Select Token',
    copy_address_success: 'Address Copied',
    loading: 'Loading…',
    logging_in: 'Logging in…',
    login_successful: 'Login successfully',
    email_format_error: 'Invalid Email',
    phone_number_format_error: 'Invalid phone number',
    confirm_button: 'Confirm',
    login_action_fogetpwdSafety: 'Security Verification',
    google_authentication: 'Google Verification',
    phone_authentication: 'Phone Verification',
    amount_greater_than_fee: 'Amount must exceed transaction fees',
    withdrawal_minimum: 'Withdrawal Floor',
    withdrawal_address_invalid: 'Invalid address',
    scan_qr_code_tip: 'Aim at QR code',
    scan_invalid_content: 'No valid content found',
    insufficient_balance: 'Insufficient balance',
    buy: 'Buy',
    sell: 'Sell',
    copy_successful: 'Copied',
    paste: 'Paste',
    safety_verification: 'Safety Verification',
    get_verification_code: 'Get Code',
    certified: 'Certified',
    verification_failed_retry: 'Verification failed, try again',
    password_rules:
      'Password must be at least 8 characters and include any three of: lowercase, uppercase, numbers, special characters',
    password_length_more_than_20: 'Maximum 20 characters',
    password_length_less_than_8: 'Minimum 8 characters',
    password_requirements:
      'Password must be at least 8 characters and include any three of: lowercase, uppercase, numbers, special characters',
    password_meets_requirements: 'Meets password requirements',
    account_registered: 'Account already registered; Log in',
    register_successfully: 'Register successfully',
    network_disconnected: 'Network disconnected',
    network_abnormal: 'Network abnormal',
    request_timeout: 'Request timeout',
    system_error_retry: 'System error, try again',
    register_agreement_privacy_desc: 'I agree to the Privacy Policy',
    cancel: 'Cancel',
    submit: 'Submit',
    reset: 'Reset',
    verification_code_hint: 'Enter verification code',
    resend: 'Resend',
    binding_phone: 'Bind Phone',
    binding_email: 'Bind Email',
    login_pass: 'Login Password',
    asset_pass: 'Asset Password',
    new_input_nickname: 'Enter nickname within 10 characters',
    success: 'Success',
    failed: 'Failed',
    spent: 'Spent',
    received: 'Received',
    receive: 'Receive',
    rejected: 'Rejected',
    please_enter_correct_information: 'Enter correct information',
    amount: 'Amount',
    available: 'Available',
    exceeds_available_balance: 'Exceeds available balance',
    min_withdraw_amount: 'Minimum withdrawal amount: %1$s %2$s (Includes fees)',
    max_withdraw_amount: 'Maximum withdrawal amount per coin: %1$s %2$s',
    get_amount: 'Amount received: %1$s %2$s',
    handling_fee_amount: 'Fee: %1$s %2$s',
    fastest: 'Priority',
    fast: 'Fast',
    normal: 'Normal',
    last_price: 'Price',
    price_limit_24h: '24h chg%',
    name: 'Name',
    time: 'Time',
    custom: 'Custom',
    gas_fee: 'Gas fee',
    state: 'State',
    price: 'Price',
    ok: 'OK',
    not_certified: 'Unauthorized',
    verified: 'Certified',
    account: 'Account',
    under_review: 'Under review',
    customSetting_action_global: 'Green for rising and red for falling',
    customSetting_action_china: 'Red for rising and green for falling',
    common_tip_logoutDesc: 'Are you sure to logout current account?',
    userinfo_tip_inputPhone: 'Invalid phone number',
    toast_email_error: 'Invalid Email',
    register_pwd_rule_tip:
      'Password must be at least 8 characters and include any three of: lowercase, uppercase, numbers, special characters',
    pwd_rule_more_than_length: 'Maximum 20 characters',
    pwd_rule_less_than_length: 'Minimum 8 characters',
    pwd_rule_contain_char_number:
      'Password must be at least 8 characters and include any three of: lowercase, uppercase, numbers, special characters',
    pwd_rule_conform_require: 'Meets password requirements',
    confirm: 'Confirm',
    choose_withdraw_network: 'Choose Network',
    withdraw_select_network_tip:
      'Note: Ensure withdrawal and deposit networks match and are supported; otherwise, assets may be lost.',
    withdraw_select_network_tip2: 'Know about network',
    input_amount_more_than_fee_tip: 'Amount must exceed transaction fees',
    subtitle_withdraw_min: 'Withdrawal Floor',
    toast_no_withdraw_address: 'Invalid Address',
    copy_success: 'Copied',
    get_code: 'Get Code',
    system_error_please_try_again: 'System error, try again',
    warn_net_disconnect: 'Network disconnected',
    warn_net_exception: 'Network abnormal',
    warn_request_timeout: 'Request timeout',
    trending: 'Trending',
    select_coin: 'Select Token',
    send: 'Send',
    history: 'History',
    network: 'Network',
    address: 'Address',
    max: 'Max',
    sent_successfully: 'Sent successfully',
    withdraw_success_tip: 'Your tokens were successfully sent to %1$s',
    market: 'Market',
    overview: 'Overview',
    volume_24h: '24H Volume',
    market_cap: 'Market Cap',
    buy_tax: 'Buy tax',
    sell_tax: 'Sell tax',
    lock_liquidity: 'Lock Liquidity',
    contract_open_source: 'Open Source',
    honeypot: 'Honeypot',
    blacklist: 'Blacklist',
    proxy_contract: 'Proxy Contract',
    potentially_scam: 'Potentially Scam',
    mintable: 'Mintable',
    slippage_modifiable: 'Slippage mondifiable',
    contract_renounced: 'Contract Renounced',
    dex_token_name: 'DEX Name:  %1$s',
    pool: 'Pool',
    pool_address: 'Pool: %1$s',
    liquidity: 'Liquidity',
    fdv: 'FDV',
    txs_24h: '24H TXs',
    total_supply: 'Total supply',
    holders: 'Holders',
    pool_created: 'Pool created',
    pooled_placeholder: 'Pooled %1$s',
    top_ten: 'Top 10',
    privacy_term: 'Privacy & Term',
    input_the_address: 'Enter the address',
    sending: 'Sending…',
    amount_to_address: '%1$s %2$s to \n %3$s',
    sent_exclamation_mark: 'Send!',
    token_were_successfully_sent_to_address:
      '%1$s %2$s were successfully sent to \n %3$s',
    view_transaction: 'View transaction',
    sending_was_canceled_by_user: 'Sending was canceled by user',
    sending_was_rejected: 'Sending was rejected',
    send_failed: 'Send failed',
    funds: 'Funds',
    transaction_failed: 'Transaction failed, try again',
    one_day: '1 Day',
    holdings: 'Holdings',
    order_history: 'Order History',
    txid: 'TXID',
    total_value: 'Total Value',
    current_price: 'Current Price',
    unealized_profits: 'Unealized Profits',
    total_cost: 'Bought',
    average_cost_price: 'Average cost price',
    realized_profits: 'Realized Profits',
    slippage: 'Slippage',
    confirming: 'Confirming…',
    completing: 'Completing…',
    cancelling: 'Cancelling…',
    expired: 'Expired',
    created: 'Created',
    pending: 'Pending',
    initial: 'Initial',
    purchase: 'Purchase',
    filled_cap: 'Filled Cap',
    get: 'Get',
    reset_password: 'Reset password',
    new_password: 'New password',
    confirm_password: 'Confirm password',
    verification_code: 'Verification Code',
    find_pwd_subtitle: 'Email',
    reset_pwd_successfully: 'Password reset successfully',
    account_unregisted: 'Account not registered',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled',
    mkt_cap: 'MKT CAP',
    system_tip: 'System message',
    swap_tip:
      'Your %1$s balance is below %2$s; transactions may fail due to insufficient gas fees.',
    continue_trading: 'Continue Anyway',
    go_to_top_up: 'Add SOL',
    completed: 'Completed',
    slippage_setting_tip:
      'Note: The slippage you set is the maximum you can accept. The system will optimize within this range, and actual slippage is usually much lower.',
    assets: 'Assets',
    hide_small_assets: 'Hide small assets',
    login_to_memeshot: 'Login to %1$s',
    create_memeshot_account: 'Create %1$s Account',
    already_have_an_account: 'Already have an account?',
    limit_trade: 'Limit',
    market_trade: 'Market',
    limit_order: 'Limit',
    buy_when_drop_to_preset: 'Buy at rate',
    sell_when_rise_to_preset: 'Sell at rate',
    validity_period: 'Expiry',
    permanent: 'Never',
    ten_minutes: '10 Minutes',
    one_hour: '1 Hour',
    three_days: '3 Day',
    thirty_days: '30 Days',
    set_validity_period: 'Set Timeframe',
    preset_buy_drop_percentage: 'Preset Buy Trigger (Drop)',
    preset_sell_rise_percentage: 'Preset Sell Trigger (Increase)',
    order_failed: 'Order Failed',
    order_created: 'Order Created',
    total_profit: 'Total Profit',
    preset_trade_price_with_type: '%1$s Trigger Price',
    month: 'Month',
    purchase_price_sol: 'Invest %1$s SOL',
    volume: 'Amount',
    cancel_limit_order: 'Cancel Limit Order',
    transaction_success: 'Completed',
    payment: 'Pay',
    obtain: 'Acquire',
    payment_address: 'Address',
    order_time: 'Order Time',
    expiry_time: 'Expired Time',
    type: 'Type',
    network_fee: 'Network Fee',
    order_placing_time: 'Listing Time',
    transaction_price: 'Execution Price',
    cancel_order_successfully: 'Order Canceled Successfully',
    view_in_solscan: 'View in Solscan',
    status: 'Status',
    order_price: 'Order Price',
    trigger_price: 'Trigger Price',
    get_price_sol: 'Acquire %1$s SOL',
    day: 'd',
    hour: 'h',
    minute: 'm',
    second: 's',
    tip_limit_trade_min_amount: 'Limit order trade amount must be at least $5',
    amount_mkt_cap: '%1$s MKT CAP',
    never: 'Never',
    login_expired: 'Login expired, please login again',
    hot: 'Trending',
    selected: 'Verified',
    favorite: 'Watchlist',
    more: 'More',
    searchBtn: 'Search',
    searchAddress: 'Search Contract',
    emailInput: 'Please enter email',
    passwordInput: 'Please enter password',
    please_complete_verification: 'Please complete the verification',
    tradeHash: 'TXID',
    noMore: 'No additional data',
    spend: 'Invest',
    slippageWarning1: 'Please enter a valid value',
    slippageWarning2: 'Slippage must less than 100%',
    futures: 'Token',
    no_more_prompts: 'Do not show anymore',
    promptTips1:
      'To ensure the success of the transaction, %1$s %2$s has been automatically allocated in your wallet as a network fee to facilitate the execution process.',
    promptTips2:
      'Transaction execution may fail due to insufficient gas, restrictive slippage, or high network congestion. To improve success rates, adjust gas fees and slippage tolerance based on current network conditions.',
    slippage_tip:
      "Slippage is the difference between a transaction's expected and actual execution price. If price fluctuations exceed your slippage tolerance, the transaction will be reverted, though network fees will still apply.",
    gas_fee_tip:
      'Gas Fee is the cost required to execute transactions on the blockchain, compensating validators for processing operations like smart contract executions and token transfers. The fee, measured in gas units, varies with transaction complexity, reflecting the computational resources consumed.',

    filter_text: 'Filter',
    sort_text: 'Sort By',
    application_text: 'Apply',
    time_slot_text: 'Time Frame',
    price_changes: 'Price Change',
    privacy_and_Term: 'Privacy & Terms',
    systemTips: 'Low ** Balance',
    inputCount: 'Enter Amount',
    toDeposit: 'Deposit **',
    continueTrade: 'Continue Anyway',
    reason: 'Reason',
    "insufficientBalance": "Insufficient balance",
    inputTips: 'Your transaction may fail due to insufficient gas fees, and gas fees will still be charged even if it fails. Ensure your wallet balance is at least ** &&.',
    orderFail: 'Order Failed',
    errorLoginExpired: 'Current login expired, please click retry',
    retry: 'Retry'
  },
  zh_CN: {
    twitter: 'X',
    facebook: 'Facebook',
    telegram: 'Telegram',
    whatsapp: 'WhatsApp',
    google: 'Google',
    perform_app_not_installed: '%1$s 应用未安装',
    about_us: '关于我们',
    no_data_available: '暂无数据',
    register: '注册',
    close: '关闭',
    phone_number_or_email: '邮箱',
    password: '密码',
    other_methods: '其他方式',
    forgot_password: '忘记密码',
    login: '登录',
    check_for_updates: '检查更新',
    security_verification: '安全验证',
    phone_verificate: '手机验证',
    email_verificate: '邮箱验证',
    google_verificate: '谷歌验证',
    google_verification_code: '谷歌验证码',
    phone_verification_code: '手机验证码',
    email_verification_code: '邮箱验证码',
    login_tip_didSendCode: '验证码已发送',
    register_action_setPassword: '设置密码',
    register_tip_repeatPassword: '请再次输入密码',
    login_action_resetPassword: '重置密码',
    toast_google_code_missing: '请输入谷歌验证码',
    toast_phone_code_missing: '请输入手机验证码',
    toast_email_code_missing: '请输入邮箱验证码',
    verification_methods_required: '所有验证方式必须通过',
    id_card_number: '身份证号',
    input_national_id: '输入您的身份证号',
    google_code: '谷歌验证码',
    next: '下一步',
    settings: '设置',
    deposit: '接收',
    deposit_qr_code_tip: '本地址只能接收%1$s网络的资产',
    save_qr_code: '保存二维码',
    deposit_network: '网络',
    deposit_asset: '接收 %1$s',
    deposit_address: '地址',
    copy: '复制',
    how_to_deposit: '如何充值？',
    language: '语言',
    search: '搜索合约',
    search_currency: '搜索合约',
    choose_country_or_area: '国家/地区：',
    country_saudi_arabia: '沙特阿拉伯',
    select_country_area: '请选择您的国家/地区',
    email: '邮箱',
    default_area_saudi_arabia: '沙特阿拉伯 (+966)',
    default_country_code: '+966',
    referral_id_hint_optional: '邀请码(可选)',
    referral_id_hint: '邀请码',
    settings_kline_color: '涨跌颜色',
    invite_friend: '邀请返佣',
    version: '版本',
    logout: '退出登录',
    settings_global_kline_color: '涨绿跌红',
    settings_china_kline_color: '涨红跌绿',
    home: '首页',
    markets: '市场',
    wallets: '资产',
    trades: '交易',
    save_success: '保存成功',
    save_fail: '保存失败',
    storage_permission_warning: '没有存储权限',
    select_currency: '选择Token',
    copy_address_success: '地址复制成功',
    loading: '加载中…',
    logging_in: '登录中…',
    login_successful: '登录成功',
    email_format_error: '邮箱格式错误',
    phone_number_format_error: '手机号格式错误',
    confirm_button: '确认',
    login_action_fogetpwdSafety: '安全验证',
    google_authentication: '谷歌验证',
    phone_authentication: '手机验证',
    amount_greater_than_fee: '输入金额必须大于网络费',
    withdrawal_minimum: '最低提币金额',
    withdrawal_address_invalid: '地址无效',
    scan_qr_code_tip: '对准二维码',
    scan_invalid_content: '扫描未发现有效内容',
    insufficient_balance: '余额不足',
    buy: '买入',
    sell: '卖出',
    copy_successful: '复制成功',
    paste: '粘贴',
    safety_verification: '安全验证',
    get_verification_code: '获取验证码',
    certified: '已认证',
    verification_failed_retry: '验证失败，请重试',
    password_rules:
      '密码至少包含小写、大写、数字或特殊字符中的两种，且不少于8位',
    password_length_more_than_20: '不能超过20个字符',
    password_length_less_than_8: '至少8个字符',
    password_requirements:
      '密码至少包含小写、大写、数字或特殊字符中的两种，且不少于8位',
    password_meets_requirements: '符合密码要求',
    account_registered: '账号已注册，请登录',
    register_successfully: '注册成功',
    network_disconnected: '网络已断开',
    network_abnormal: '网络异常',
    request_timeout: '请求超时',
    system_error_retry: '系统错误，请重试',
    register_agreement_privacy_desc: '我已阅读并同意Memeshot隐私协议',
    cancel: '取消',
    submit: '提交',
    reset: '重置',
    verification_code_hint: '输入验证码',
    resend: '重新发送',
    binding_phone: '绑定手机',
    binding_email: '绑定邮箱',
    login_pass: '登录密码',
    asset_pass: '资产密码',
    new_input_nickname: '请输入10个字符以内的新昵称',
    success: '成功',
    failed: '失败',
    spent: '成本',
    received: '收到',
    receive: '接收',
    rejected: '已拒绝',
    please_enter_correct_information: '请输入正确的信息',
    amount: '金额',
    available: '可用',
    exceeds_available_balance: '超出可用余额',
    min_withdraw_amount: '最低提币金额：%1$s %2$s（含手续费）',
    max_withdraw_amount: '每种货币的最大提币金额：%1$s %2$s',
    get_amount: '收到金额：%1$s %2$s',
    handling_fee_amount: '手续费：%1$s %2$s',
    fastest: '极速',
    fast: '快速',
    normal: '正常',
    last_price: '价格',
    price_limit_24h: '24小时涨跌%',
    name: '名称',
    time: '时间',
    custom: '自定义',
    gas_fee: '网络费(Gas fee)',
    state: '状态',
    price: '价格',
    ok: '确定',
    not_certified: '未认证',
    verified: '已认证',
    account: '账户',
    under_review: '审核中',
    customSetting_action_global: '绿涨红跌',
    customSetting_action_china: '红涨绿跌',
    common_tip_logoutDesc: '确定要退出当前账户吗？',
    userinfo_tip_inputPhone: '无效的手机号码',
    toast_email_error: '无效的邮箱',
    register_pwd_rule_tip:
      '密码必须至少8个字符，并包含以下三种中的任何三种：小写字母、大写字母、数字、特殊字符',
    pwd_rule_more_than_length: '最多20个字符',
    pwd_rule_less_than_length: '最少8个字符',
    pwd_rule_contain_char_number:
      '密码必须至少8个字符，并包含以下三种中的任何三种：小写字母、大写字母、数字、特殊字符',
    pwd_rule_conform_require: '符合密码要求',
    confirm: '确认',
    choose_withdraw_network: '选择网络',
    withdraw_select_network_tip:
      '注意：请确保选网络与充值网络匹配，否则资产将会丢失。',
    withdraw_select_network_tip2: '了解网络',
    input_amount_more_than_fee_tip: '输入金额必须大于交易费用。',
    subtitle_withdraw_min: '提现下限',
    toast_no_withdraw_address: '地址无效',
    copy_success: '复制成功',
    get_code: '获取验证码',
    system_error_please_try_again: '系统错误，请重试',
    warn_net_disconnect: '网络已断开',
    warn_net_exception: '网络异常',
    warn_request_timeout: '请求超时',
    trending: '热门',
    select_coin: '选Token',
    send: '发送',
    history: '历史',
    network: '网络',
    address: '地址',
    max: '全部',
    sent_successfully: '发送成功',
    withdraw_success_tip: '你的token已成功发送至 %1$s',
    market: '市场',
    overview: '信息',
    volume_24h: '24H交易量',
    market_cap: '市值',
    buy_tax: '买入税',
    sell_tax: '卖出税',
    lock_liquidity: '流动性锁定',
    contract_open_source: '合约开源',
    honeypot: '非蜜蜂',
    blacklist: '无黑名单',
    proxy_contract: '非代理合同',
    potentially_scam: '非潜在诈骗',
    mintable: '可铸造',
    slippage_modifiable: '滑点不可变',
    contract_renounced: '合约弃权',
    dex_token_name: '去中心化交易所名称:  %1$s',
    pool: '池子',
    pool_address: '池子: %1$s',
    liquidity: '流动性',
    fdv: 'FDV',
    txs_24h: '24H交易次数（买/卖）',
    total_supply: 'Token总量',
    holders: '总持有人',
    pool_created: '池子创建时间',
    pooled_placeholder: '池子 %1$s',
    top_ten: 'Top 10',
    privacy_term: '隐私与条款',
    input_the_address: '输入地址',
    sending: '发送中…',
    amount_to_address: '%1$s %2$s 至 \n %3$s',
    sent_exclamation_mark: '发送!',
    token_were_successfully_sent_to_address: '%1$s %2$s 已成功发送至 \n %3$s',
    view_transaction: '查看交易',
    sending_was_canceled_by_user: '发送被用户取消',
    sending_was_rejected: '发送被拒绝',
    send_failed: '发送失败',
    funds: '资产',
    transaction_failed: '交易失败，重试',
    one_day: '1天',
    holdings: '持仓',
    order_history: '历史',
    txid: 'TXID',
    total_value: '当前总价价值',
    current_price: '当前价格',
    unealized_profits: '未实现利润',
    total_cost: '总成本',
    average_cost_price: '平均成本价格',
    realized_profits: '已实现利润',
    slippage: '滑点',
    confirming: '确认中…',
    completing: '完成中…',
    cancelling: '取消中…',
    expired: '过期',
    created: '已创建',
    pending: '挂单中',
    initial: '初始化',
    purchase: '购买',
    filled_cap: '已填充上限',
    get: '获取',
    reset_password: '重置密码',
    new_password: '新密码',
    confirm_password: '确认密码',
    verification_code: '验证码',
    find_pwd_subtitle: '邮箱',
    reset_pwd_successfully: '重置密码成功',
    account_unregisted: '未注册账号',
    confirmed: '已确认',
    cancelled: '已取消',
    mkt_cap: '市值',
    system_tip: '系统提示',
    swap_tip:
      '你当前钱包中%1$s余额小于%2$s,可能会因为网络费（Gas fee）不足导致交易失败。',
    continue_trading: '继续交易',
    go_to_top_up: '充值SOL',
    completed: '已完成',
    slippage_setting_tip:
      '注意:您设定的滑点值为可接受的最大范围。系统将在该范围内智能选择最优滑点,通常实际滑点会远低于您的上限。',
    assets: '资产',
    hide_small_assets: '隐藏小额资产',
    login_to_memeshot: '登录 %1$s',
    create_memeshot_account: '创建 %1$s 账户',
    already_have_an_account: '已经有账户？',
    limit_trade: '限价',
    market_trade: '市价',
    limit_order: '限价单',
    buy_when_drop_to_preset: '到达跌幅预设买入',
    sell_when_rise_to_preset: '到达涨幅预设卖出',
    validity_period: '有效期',
    permanent: '永久',
    ten_minutes: '10分钟',
    one_hour: '1小时',
    three_days: '3天',
    thirty_days: '30天',
    set_validity_period: '设置有效期',
    preset_buy_drop_percentage: '预设买入跌幅',
    preset_sell_rise_percentage: '预设卖出涨幅',
    order_failed: '订单失败',
    order_created: '订单已创建',
    total_profit: '总利润',
    preset_trade_price_with_type: '预设%1$s交易价格',
    month: '月',
    purchase_price_sol: '花费 %1$s SOL',
    volume: '数量',
    cancel_limit_order: '撤销限价单',
    transaction_success: '交易成功',
    payment: '支付',
    obtain: '获得',
    payment_address: '支付地址',
    order_time: '下单时间',
    expiry_time: '过期时间',
    type: '类型',
    network_fee: '网络费',
    order_placing_time: '挂单时间',
    transaction_price: '成交价格',
    cancel_order_successfully: '撤单成功',
    view_in_solscan: '在Solscan中查看',
    status: '状态',
    order_price: '下单价格',
    trigger_price: '触发价格',
    get_price_sol: '获取 %1$s SOL',
    day: '天',
    hour: '时',
    minute: '分',
    second: '秒',
    tip_limit_trade_min_amount: '限价单交易金额至少为 5 美元',
    amount_mkt_cap: '%1$s 市值',
    never: '永久',
    login_expired: '登录过期，请重新登录',
    hot: '热门',
    selected: '精选',
    favorite: '关注',
    more: '更多',
    searchBtn: '搜索',
    searchAddress: '搜索地址',
    emailInput: '请输入邮箱',
    passwordInput: '请输入密码',
    please_complete_verification: '请完成验证',
    tradeHash: '交易哈希',
    noMore: '暂无更多数据',
    spend: '花费',
    slippageWarning1: '请输入有效值',
    slippageWarning2: '滑点值不能大于100%',
    futures: '币种',
    no_more_prompts: '不再提示',
    promptTips1:
      '为避免交易失败，已在钱包中预留 %1$s %2$s 作为交易时的网络费用 。',
    promptTips2:
      '交易失败的原因可能是因为，网络费过低、滑点值过小、网络拥堵造成。\n可以通过提高网络费、滑点值来提供交易成功率。',
    slippage_tip:
      '滑点是指交易的预期价格与交易执行价格之间的差额。如果交易的价格变化超过滑点设置，你的交易将被取消，但依然会收取网络费用。',
    gas_fee_tip:
      'Gas Fee是在区块链验证中，用户支付给矿工执行特定行为（如执行合约或是发送代币）所需要消耗的燃料。区块链上的每笔交易都需要消耗计算资源，而矿工必须负担这些成本。',

    filter_text: '筛选',
    sort_text: '排序',
    application_text: '应用',
    time_slot_text: '时间段',
    price_changes: '价格变化',
    privacy_Term: '隐私与条款',
    systemTips: '系统提示',
    inputCount: '输入数量',
    toDeposit: '去充币',
    continueTrade: '继续交易',
    reason: '原因',
    "insufficientBalance": "余额不足",
    inputTips: '交易可能因网络费（Gas fee）用不足而失败，失败仍会扣除gas费,请确保钱包余额至少为**&& 。',
    orderFail: '订单失败',
    errorLoginExpired: '当前登录已过期，请点击重试',
    retry: '重试'
  },
  ar_SA: {
    twitter: 'تويتر',
    facebook: 'فيسبوك',
    telegram: 'تليقرام',
    whatsapp: 'واتس اب',
    google: 'جوجل',
    perform_app_not_installed: 'التطبيق ليس مثبّتًا %1$s',
    about_us: 'من نحن',
    no_data_available: 'لا توجد بيانات',
    register: 'إنشاء حساب',
    close: 'إغلاق',
    phone_number_or_email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    other_methods: 'طرق أخرى',
    forgot_password: 'نسيت كلمة المرور',
    login: 'تسجيل الدخول',
    check_for_updates: 'تحقق من التحديثات',
    security_verification: 'التحقق الأمني',
    phone_verificate: 'التحقق عبر الهاتف',
    email_verificate: 'تحقق البريد الإلكتروني',
    google_verificate: 'التحقق عبر جوجل',
    google_verification_code: 'رمز تحقق جوجل',
    phone_verification_code: 'رمز تحقق الهاتف',
    email_verification_code: 'رمز تحقق البريد الإلكتروني',
    login_tip_didSendCode: 'تم إرسال رمز التحقق',
    register_action_setPassword: 'قم بتعيين كلمة مرور',
    register_tip_repeatPassword: 'يرجى إعادة إدخال كلمة المرور',
    login_action_resetPassword: 'إعادة تعيين كلمة المرور',
    toast_google_code_missing: 'أدخل رمز تحقق جوجل',
    toast_phone_code_missing: 'أدخل رمز تحقق عبر الهاتف',
    toast_email_code_missing: 'أدخل رمز تحقق البريد الإلكتروني',
    verification_methods_required: 'يجب اجتياز جميع طرق التحقق',
    id_card_number: 'رقم الهوية',
    input_national_id: 'أدخل رقم الهوية الوطنية',
    google_code: 'رمز جوجل',
    next: 'التالي',
    settings: 'الإعدادات',
    deposit: 'استلام',
    deposit_qr_code_tip: 'يستلم هذا العنوان أصول شبكة %1$s  فقط',
    save_qr_code: 'حفظ الباركود',
    deposit_network: 'الشبكة',
    deposit_asset: 'استلام %1$s',
    deposit_address: 'العنوان',
    copy: 'نسخ',
    how_to_deposit: 'كيفية إيداع العملات؟',
    language: 'اللغة',
    search: 'بحث بعنوان العقد أو اسم العملة',
    search_currency: 'بحث',
    choose_country_or_area: 'الدولة/المنطقة:',
    country_saudi_arabia: 'المملكة العربية السعودية',
    select_country_area: 'يرجى اختيار دولتك/منطقتك',
    email: 'البريد الإلكتروني',
    default_area_saudi_arabia: 'المملكة العربية السعودية (+966)',
    default_country_code: '+966',
    referral_id_hint_optional: 'رمز الدعوة (اختياري)',
    referral_id_hint: 'رمز الدعوة',
    settings_kline_color: 'لون الصعود/الهبوط',
    invite_friend: 'الإحالات',
    version: 'الإصدار',
    logout: 'تسجيل خروج',
    settings_global_kline_color: 'الأخضر للصعود والأحمر للهبوط',
    settings_china_kline_color: 'الأحمر للصعود والأخضر للهبوط',
    home: 'الصفحة الرئيسية',
    markets: 'السوق',
    wallets: 'المحافظ',
    trades: 'التداول',
    save_success: 'تم الحفظ بنجاح',
    save_fail: 'فشل في الحفظ',
    storage_permission_warning: 'لا توجد صلاحية تخزين',
    select_currency: 'اختر العملة',
    copy_address_success: 'تم نسخ العنوان بنجاح',
    loading: 'جارٍ التحميل…',
    logging_in: 'جارٍ تسجيل الدخول…',
    login_successful: 'تم تسجيل الدخول بنجاح',
    email_format_error: 'بريد إلكتروني خاطئ',
    phone_number_format_error: 'رقم الهاتف خاطئ',
    confirm_button: 'تأكيد',
    login_action_fogetpwdSafety: 'التحقق الأمني',
    google_authentication: 'التحقق عبر جوجل',
    phone_authentication: 'التحقق الهاتف',
    amount_greater_than_fee: 'المبلغ يجب أن يتجاوز رسوم المعاملة',
    withdrawal_minimum: 'الحد الأدنى للسحب',
    withdrawal_address_invalid: 'عنوان خاطئ',
    scan_qr_code_tip: 'ضع الباركود في مربع المسح',
    scan_invalid_content: 'لم يتم العثور على محتوى قابل للمسح',
    insufficient_balance: 'الرصيد غير كافٍ',
    buy: 'شراء',
    sell: 'بيع',
    copy_successful: 'تم النسخ بنجاح',
    paste: 'لصق',
    safety_verification: 'التحقق الأمني',
    get_verification_code: 'احصل على رمز التحقق',
    certified: 'موثق',
    verification_failed_retry: 'فشل التحقق، حاول مرة أخرى',
    password_rules:
      'يجب أن تحتوي على ثلاثة على الأقل من الأحرف الصغيرة، الأحرف الكبيرة، الأرقام، أو الرموز الخاصة',
    password_length_more_than_20: 'يجب أن تكون كلمة المرور بين 8 و20 حرفًا',
    password_length_less_than_8: 'يجب أن تكون كلمة المرور بين 8 و20 حرفًا',
    password_requirements:
      'يجب أن تحتوي على ثلاثة على الأقل من الأحرف الصغيرة، الأحرف الكبيرة، الأرقام، أو الرموز الخاصة',
    password_meets_requirements: 'تُحقق شروط كلمة المرور',
    account_registered: 'الحساب موجود بالفعل، سجل دخول.',
    register_successfully: 'تم تسجيل الدخول بنجاح',
    network_disconnected: 'الاتصال بالشبكة مقطوع',
    network_abnormal: 'الشبكة غير مستقرة',
    request_timeout: 'انتهت مهلة الاستجابة',
    system_error_retry: 'خطأ في النظام، حاول مرة أخرى',
    register_agreement_privacy_desc:
      'أوافق على سياسة الخصوصية الخاصة بـ Memeshot',
    cancel: 'إلغاء',
    submit: 'إرسال',
    reset: 'إعادة تعيين',
    verification_code_hint: 'أدخل رمز التحقق',
    resend: 'إعادة الإرسال',
    binding_phone: 'ربط الهاتف',
    binding_email: 'ربط البريد الإلكتروني',
    login_pass: 'كلمة المرور',
    asset_pass: 'كلمة مرور الأصول',
    new_input_nickname: 'إدخال اسم لا يتجاوز 10 أحرف',
    success: 'نجح',
    failed: 'فشل',
    spent: 'التكلفة',
    received: 'تم الاستلام',
    receive: 'استلام',
    rejected: 'مرفوض',
    please_enter_correct_information: 'إدخال بيانات صحيحة',
    amount: 'المبلغ',
    available: 'متاح',
    exceeds_available_balance: 'الرصيد غير كافٍ',
    min_withdraw_amount: 'الحد الأدنى للسحب: %1$s %2$s (شامل الرسوم)',
    max_withdraw_amount: 'الحد الأقصى للسحب لكل عملة: %1$s %2$s',
    get_amount: 'المبلغ المستلم: %1$s %2$s',
    handling_fee_amount: 'الرسوم: %1$s %2$s',
    fastest: 'أولوية',
    fast: 'سريع',
    normal: 'عادي',
    last_price: 'السعر',
    price_limit_24h: 'تغيير 24 ساعة%',
    name: 'الاسم',
    time: 'الوقت',
    custom: 'مخصص',
    gas_fee: 'رسوم الغاز',
    state: 'الحالة',
    price: 'السعر',
    ok: 'موافق',
    not_certified: 'غير معتمد',
    verified: 'معتمد',
    account: 'محفظتك',
    under_review: 'قيد المراجعة',
    customSetting_action_global: 'الأخضر للصعود والأحمر للهبوط',
    customSetting_action_china: 'الأحمر للصعود والأخضر للهبوط',
    common_tip_logoutDesc: 'هل تريد تسجيل الخروج؟',
    userinfo_tip_inputPhone: 'رقم الهاتف خاطئ',
    toast_email_error: 'البريد الإلكتروني خاطئ',
    register_pwd_rule_tip:
      'يجب أن تحتوي على ثلاثة على الأقل من الأحرف الصغيرة، الأحرف الكبيرة، الأرقام، أو الرموز الخاصة',
    pwd_rule_more_than_length: 'يجب أن تكون كلمة المرور بين 8 و20 حرفًا',
    pwd_rule_less_than_length: 'يجب أن تكون كلمة المرور بين 8 و20 حرفًا',
    pwd_rule_contain_char_number:
      'يجب أن تحتوي على ثلاثة على الأقل من الأحرف الصغيرة، الأحرف الكبيرة، الأرقام، أو الرموز الخاصة',
    pwd_rule_conform_require: 'تُحقق شروط كلمة المرور',
    confirm: 'تأكيد',
    choose_withdraw_network: 'اختر الشبكة',
    withdraw_select_network_tip:
      'ملحوظة: تحقق من تطابق شبكة سحب مع شبكة الإيداع. وإلا قد تفقد أصولك.',
    withdraw_select_network_tip2: 'تعرف على شبكة السحب',
    input_amount_more_than_fee_tip: 'المبلغ يجب أن يتجاوز رسوم المعاملة',
    subtitle_withdraw_min: 'الحد الأدنى للسحب',
    toast_no_withdraw_address: 'عنوان خاطئ',
    copy_success: 'تم النسخ بنجاح',
    get_code: 'أرسال الرمز',
    system_error_please_try_again: 'خطأ في النظام، حاول مرة أخرى',
    warn_net_disconnect: 'الاتصال بالشبكة مقطوع',
    warn_net_exception: 'الشبكة غير مستقرة',
    warn_request_timeout: 'انتهت مهلة الاستجابة',
    trending: 'العملات الرائجة',
    select_coin: 'حدد العملة',
    send: 'أرسال',
    history: 'السجلات',
    network: 'شبكة',
    address: 'العنوان',
    max: 'الكل',
    sent_successfully: 'تم الأرسال بنجاح',
    withdraw_success_tip: 'تم أرسال عملاتك بنجاح لـ %1$s',
    market: 'السوق',
    overview: 'نظرة عامة',
    volume_24h: 'التداول(24 ساعة)',
    market_cap: 'القيمة السوقية',
    buy_tax: 'ضريبة شراء',
    sell_tax: 'ضريبة بيع',
    lock_liquidity: 'سيولة مغلقة',
    contract_open_source: 'مفتوح المصدر',
    honeypot: 'مصيدة العسل',
    blacklist: 'قائمة سوداء',
    proxy_contract: 'عقد وكيل',
    potentially_scam: 'احتيال محتمل',
    mintable: 'قابل للسك',
    slippage_modifiable: 'أنزلاق قابل للتعديل',
    contract_renounced: 'لا صلاحيات',
    dex_token_name: 'المنصة اللامركزية: %1$s',
    pool: 'حوض السيولة',
    pool_address: 'حوض السيولة: %1$s',
    liquidity: 'السيولة',
    fdv: 'FDV',
    txs_24h: 'عدد المعاملات (24 ساعة)',
    total_supply: 'إجمالي العرض',
    holders: 'عدد المالكين',
    pool_created: 'وقت إنشاء الحوض',
    pooled_placeholder: 'في الحوض%1$sعدد',
    top_ten: 'نسبة أكثر 10 مالكين',
    privacy_term: 'الخصوصية والشروط',
    input_the_address: 'إدخل العنوان',
    sending: 'أرسال…',
    amount_to_address: '%1$s %2$s الى \n %3$s',
    sent_exclamation_mark: 'أرسال!',
    token_were_successfully_sent_to_address:
      '%1$s %2$s تم الأرسال بنجاح الى \n %3$s',
    view_transaction: 'عرض المعاملة',
    sending_was_canceled_by_user: 'تم إلغاء من المستخدم',
    sending_was_rejected: 'تم رفض الأرسال',
    send_failed: 'فشل الأرسال',
    funds: 'الأصول',
    transaction_failed: 'فشلت المعاملة، حاول مرة اخرى',
    one_day: '1 يوم',
    holdings: 'أصولي',
    order_history: 'الطلبات',
    txid: 'تفاصيل',
    total_value: 'القيمة الإجمالية',
    current_price: 'السعر الحالي',
    unealized_profits: 'الأرباح غير المحققة',
    total_cost: 'التكلفة الإجمالية',
    average_cost_price: 'متوسط السعر',
    realized_profits: 'الأرباح المحققة',
    slippage: 'الانزلاق',
    confirming: 'جاري التأكيد…',
    completing: 'جاري الأكمال…',
    cancelling: 'جار الإلغاء',
    expired: 'منتهي الصلاحية',
    created: 'تم الإنشاء',
    pending: 'الحد',
    initial: 'أولي',
    purchase: 'شراء',
    filled_cap: 'السعة المملوءة',
    get: 'احصل على',
    reset_password: 'إعادة تعيين كلمة المرور',
    new_password: 'كلمة المرور الجديدة',
    confirm_password: 'تأكيد كلمة المرور',
    verification_code: 'رمز التحقق',
    find_pwd_subtitle: 'البريد الإلكتروني',
    reset_pwd_successfully: 'تم إعادة التعيين بنجاح',
    account_unregisted: 'الحساب غير مسجل',
    confirmed: 'تم التأكيد',
    cancelled: 'تم الإلغاء',
    mkt_cap: 'القيمة السوقية',
    system_tip: 'أشعار',
    swap_tip:
      'رصيدك من عملة %1$s أقل من %2$s؛ قد تفشل المعاملة بسبب عدم كفاية رسوم الشبكة (الغاز).',
    continue_trading: 'المتابعة',
    go_to_top_up: 'إيداع SOL',
    completed: 'مكتمل',
    slippage_setting_tip:
      'ملاحظة: الانزلاق الذي تحدده يمثل أعلى قيمة يمكنك قبولها. سيقوم النظام باختيار الانزلاق الأنسب ضمن هذا النطاق، وغالبًا ما يكون الانزلاق الفعلي أقل بكثير من الحد الاقصى.',
    assets: 'الأصول',
    hide_small_assets: 'إخفاء الأصول الصغيرة',
    login_to_memeshot: ' تسجيل الدخول إلى %1$s',
    create_memeshot_account: 'إنشاء حساب %1$s',
    already_have_an_account: 'هل لديك حساب؟',
    limit_trade: 'الحد',
    market_trade: 'السوق',
    limit_order: 'الحد',
    buy_when_drop_to_preset: 'الشراء عند',
    sell_when_rise_to_preset: 'البيع عند',
    validity_period: 'المدة الزمنية',
    permanent: 'دائم',
    ten_minutes: '10 دقائق',
    one_hour: '1 ساعة',
    three_days: '3 يوم',
    thirty_days: '30 يوم',
    set_validity_period: 'إعداد المدة الزمنية',
    preset_buy_drop_percentage: 'إعداد الشراء عند الانخفاض',
    preset_sell_rise_percentage: 'إعداد البيع عند الصعود',
    order_failed: 'الطلب فشل',
    order_created: 'تم إنشاء الطلب',
    total_profit: 'الربح الكلي',
    preset_trade_price_with_type: 'السعر المستهدف لـ%1$s',
    month: 'شهر',
    purchase_price_sol: 'استثمار %1$s SOL',
    volume: 'الكمية',
    cancel_limit_order: 'إلغاء طلب الحد',
    transaction_success: 'نجح',
    payment: 'دفع',
    obtain: 'حصول على',
    payment_address: 'عنوان',
    order_time: 'وقت الطلب',
    expiry_time: 'وقت الانتهاء',
    type: 'نوع الطلب',
    network_fee: 'رسوم الغاز',
    order_placing_time: 'وقت إنشاء الطلب',
    transaction_price: 'السعر',
    cancel_order_successfully: 'تم إلغاء الطلب بنجاح',
    view_in_solscan: 'التفاصيل',
    status: 'الحالة',
    order_price: 'السعر وقت الطلب',
    trigger_price: 'السعر المستهدف',
    get_price_sol: 'الحصول على %1$s SOL',
    day: 'يوم',
    hour: 'ساعة',
    minute: 'دقيقة',
    second: 'ثانية',
    tip_limit_trade_min_amount: "يجب أن يكون مبلغ الطلب بالحد 5 دولارات على الأقل",
    amount_mkt_cap: '%1$s القيمة السوقية',
    never: 'دائم',
    login_expired: 'انتهت صلاحية الدخول. أعد تسجيل الدخول',
    hot: 'الرائجة',
    selected: 'مُختاره',
    favorite: 'المفضلة',
    more: 'المزيد',
    searchBtn: 'بحث',
    searchAddress: 'البحث بعنوان العملة',
    emailInput: 'أدخل البريد الإلكتروني',
    passwordInput: 'أدخل كلمة المرور',
    please_complete_verification: 'يرجى إكمال التحقق',
    tradeHash: 'التفاصيل',
    noMore: 'لا بيانات إضافية',
    spend: 'استثمار',
    slippageWarning1: 'يرجى أدخال قيمة صحيحة',
    slippageWarning2: 'الانزلاق يجب أن يكون أقل من 100%',
    futures: 'العملة',
    no_more_prompts: 'لا تظهر هذه الرسالة مرة أخرى',
    promptTips1:
      'لضمان نجاح المعاملة، تم تخصيص %1$s %2$s تلقائياً في محفظتك كرسوم شبكة لتسهيل عملية التنفيذ.',
    promptTips2:
      'قد تفشل المعاملة لعدة أسباب: عدم كفاية رسوم الشبكة، أو تحديد نسبة انزلاق منخفضة للغاية، أو ازدحام الشبكة. يمكن تحسين معدل نجاح المعاملات من خلال زيادة رسوم الشبكة وتعديل نسبة الانزلاق.',
    slippage_tip:
      'الانزلاق هو الفارق بين السعر المتوقع للمعاملة والسعر الفعلي عند التنفيذ. عندما تتجاوز تقلبات الأسعار حد الانزلاق المحدد، ستفشل المعاملة، مع العلم أنه سيتم خصم رسوم الشبكة حتى في حال فشل الطلب.',
    gas_fee_tip:
      'رسوم الغاز هي تكلفة تشغيل المعاملات على شبكة البلوكتشين، حيث تُستخدم لتعويض المُعدِّنين عن الموارد الحسابية المستهلكة في معالجة وتأكيد العمليات مثل تنفيذ العقود الذكية وتحويل الرموز. تتناسب هذه الرسوم مع تعقيد المعاملة وحالة ازدحام الشبكة.',
    filter_text: 'تصفية',
    sort_text: 'ترتيب',
    application_text: 'تأكيد',
    time_slot_text: 'الفترة الزمنية',
    price_changes: 'تغير السعر',
    privacy_and_Term: 'الخصوصية والشروط',
    systemTips: 'رصيد ** منخفض',
    inputCount: 'أدخل المبلغ',
    toDeposit: 'إيداع **',
    continueTrade: 'المتابعة',
    reason: 'السبب',
    "insufficientBalance": "الرصيد غير كافٍ",
    inputTips: "قد تفشل معاملتك بسبب نقص رسوم الشبكة (الغاز)، وسيتم خصم رسوم الشبكة حتى لو فشلت. حافظ على رصيد محفظتك بحد أدنى**&&.",
    orderFail: 'فشل الطلب',
    errorLoginExpired: 'جلسة الدخول الحالية منتهية، يرجى النقر فوق إعادة المحاولة',
    retry: 'حاول مرة أخرى',
  },
  tr_TR: {
    twitter: 'Twitter',
    facebook: 'Facebook',
    telegram: 'Telegram',
    whatsapp: 'WhatsApp',
    google: 'Google',
    perform_app_not_installed: '%1$s uygulaması yok',
    about_us: 'Hakkımızda',
    no_data_available: 'Veri yok',
    register: 'Kaydol',
    close: 'Kapat',
    phone_number_or_email: 'E-posta',
    password: 'Şifre',
    other_methods: 'Diğer yöntemler',
    forgot_password: 'Şifremi unuttum',
    login: 'Giriş Yap',
    check_for_updates: 'Güncellemeleri kontrol et',
    security_verification: 'Güvenlik doğrulaması',
    phone_verificate: 'Telefon doğrulaması',
    email_verificate: 'E-posta doğrulaması',
    google_verificate: 'Google doğrulaması',
    google_verification_code: 'Google doğrulama kodu',
    phone_verification_code: 'Telefon doğrulama kodu',
    email_verification_code: 'E-posta doğrulama kodu',
    login_tip_didSendCode: 'Doğrulama kodu gönderildi',
    register_action_setPassword: 'Şifre belirle',
    register_tip_repeatPassword: 'Şifreyi tekrar gir',
    login_action_resetPassword: 'Şifreyi sıfırla',
    toast_google_code_missing: 'Google doğrulama kodunu gir',
    toast_phone_code_missing: 'Telefon doğrulama kodunu gir',
    toast_email_code_missing: 'E-posta doğrulama kodunu gir',
    verification_methods_required: 'Tüm doğrulama yöntemleri onaylanmalı',
    id_card_number: 'Kimlik numarası',
    input_national_id: 'TC kimlik numaranızı girin',
    google_code: 'Google kodu',
    next: 'İleri',
    settings: 'Ayarlar',
    deposit: 'Al',
    deposit_qr_code_tip: 'Bu adres yalnızca %1$s ağ varlıklarını alabilir',
    save_qr_code: 'QR kodunu kaydet',
    deposit_network: 'Ağ',
    deposit_asset: '%1$s al',
    deposit_address: 'Adres',
    copy: 'Kopyala',
    how_to_deposit: 'Nasıl yatırılır?',
    language: 'Dil',
    search: 'Sözleşme ara',
    search_currency: 'Sözleşme ara',
    choose_country_or_area: 'Ülke/Bölge:',
    country_saudi_arabia: 'Suudi Arabistan',
    select_country_area: 'Ülke/Bölge seçin',
    email: 'E-posta',
    default_area_saudi_arabia: 'SUUDİ ARABİSTAN (+966)',
    default_country_code: '+966',
    referral_id_hint_optional: 'Davet kodu (isteğe bağlı)',
    referral_id_hint: 'Davet kodu',
    settings_kline_color: 'Artış/Azalış rengi',
    invite_friend: 'Referans',
    version: 'Sürüm',
    logout: 'Çıkış',
    settings_global_kline_color: 'Artış için yeşil, düşüş için kırmızı',
    settings_china_kline_color: 'Artış için kırmızı, düşüş için yeşil',
    home: 'Ana Sayfa',
    markets: 'Piyasalar',
    wallets: 'Varlıklar',
    trades: 'İşlem',
    save_success: 'Kaydedildi',
    save_fail: 'Kaydedilemedi',
    storage_permission_warning: 'Depolama izni yok',
    select_currency: 'Token seç',
    copy_address_success: 'Adres kopyalandı',
    loading: 'Yükleniyor…',
    logging_in: 'Giriş yapılıyor…',
    login_successful: 'Başarıyla giriş yapıldı',
    email_format_error: 'Geçersiz e-posta',
    phone_number_format_error: 'Geçersiz telefon numarası',
    confirm_button: 'Onayla',
    login_action_fogetpwdSafety: 'Güvenlik doğrulaması',
    google_authentication: 'Google doğrulaması',
    phone_authentication: 'Telefon doğrulaması',
    amount_greater_than_fee: 'Tutar işlem ücretini aşmalı',
    withdrawal_minimum: 'Minimum çekim',
    withdrawal_address_invalid: 'Geçersiz adres',
    scan_qr_code_tip: 'QR koduna doğrultun',
    scan_invalid_content: 'Geçerli içerik yok',
    insufficient_balance: 'Yetersiz bakiye',
    buy: 'Satın al',
    sell: 'Sat',
    copy_successful: 'Kopyalandı',
    paste: 'Yapıştır',
    safety_verification: 'Güvenlik doğrulaması',
    get_verification_code: 'Kod al',
    certified: 'Sertifikalı',
    verification_failed_retry: 'Doğrulama başarısız, tekrar deneyin',
    password_rules:
      'Şifre en az 8 karakter ve üç farklı tür karakter (küçük, büyük harf, rakam, özel karakter) içermeli',
    password_length_more_than_20: 'En fazla 20 karakter',
    password_length_less_than_8: 'En az 8 karakter',
    password_requirements:
      'Şifre en az 8 karakter ve üç farklı tür karakter içermeli',
    password_meets_requirements: 'Şifre gereksinimlerini karşılıyor',
    account_registered: 'Hesap zaten kayıtlı; Giriş yapın',
    register_successfully: 'Başarıyla kaydedildi',
    network_disconnected: 'Ağ kesildi',
    network_abnormal: 'Ağ sorunu',
    request_timeout: 'Zaman aşımı',
    system_error_retry: 'Sistem hatası, tekrar deneyin',
    register_agreement_privacy_desc: 'Gizlilik politikasını kabul ediyorum',
    cancel: 'İptal',
    submit: 'Gönder',
    reset: 'Sıfırla',
    verification_code_hint: 'Doğrulama kodu gir',
    resend: 'Tekrar gönder',
    binding_phone: 'Telefon bağla',
    binding_email: 'E-posta bağla',
    login_pass: 'Giriş Şifresi',
    asset_pass: 'Varlık Şifresi',
    new_input_nickname: '10 karakteri aşma',
    success: 'Başarılı',
    failed: 'Başarısız',
    spent: 'Harcanan',
    received: 'Alınan',
    receive: 'Al',
    rejected: 'Reddedildi',
    please_enter_correct_information: 'Doğru bilgi gir',
    amount: 'Miktar',
    available: 'Mevcut',
    exceeds_available_balance: 'Bakiye yetersiz',
    min_withdraw_amount: 'Min çekim: %1$s %2$s (ücret dahil)',
    max_withdraw_amount: 'Maks çekim/coin: %1$s %2$s',
    get_amount: 'Alınan: %1$s %2$s',
    handling_fee_amount: 'Ücret: %1$s %2$s',
    fastest: 'Öncelik',
    fast: 'Hızlı',
    normal: 'Normal',
    last_price: 'Fiyat',
    price_limit_24h: '24s değişim%',
    name: 'İsim',
    time: 'Zaman',
    custom: 'Özel',
    gas_fee: 'Gas ücreti',
    state: 'Durum',
    price: 'Fiyat',
    ok: 'Tamam',
    not_certified: 'Yetkisiz',
    verified: 'Sertifikalı',
    account: 'Hesap',
    under_review: 'İnceleniyor',
    customSetting_action_global: 'Yükseliş=Yeşil, Düşüş=Kırmızı',
    customSetting_action_china: 'Yükseliş=Kırmızı, Düşüş=Yeşil',
    common_tip_logoutDesc: 'Hesaptan çıkış yapılsın mı?',
    userinfo_tip_inputPhone: 'Geçersiz telefon',
    toast_email_error: 'Geçersiz e-posta',
    register_pwd_rule_tip:
      'Şifre min 8 karakter, 3 çeşit: küçük, büyük, sayı/özel',
    pwd_rule_more_than_length: 'Maks 20 karakter',
    pwd_rule_less_than_length: 'Min 8 karakter',
    pwd_rule_contain_char_number: 'Şifre min 8 karakter, 3 çeşit gerekli',
    pwd_rule_conform_require: 'Şifre uygun',
    confirm: 'Onayla',
    choose_withdraw_network: 'Ağı seç',
    withdraw_select_network_tip:
      'Not: Çekim/yatırma ağı uyumlu ve destekli olmalı, yoksa varlıklar kaybolabilir.',
    withdraw_select_network_tip2: 'Ağ hakkında bilgi',
    input_amount_more_than_fee_tip: 'Miktar işlem ücretini aşmalı',
    subtitle_withdraw_min: 'Min çekim',
    toast_no_withdraw_address: 'Geçersiz adres',
    copy_success: 'Kopyalandı',
    get_code: 'Kod al',
    system_error_please_try_again: 'Sistem hatası, tekrar deneyin',
    warn_net_disconnect: 'Ağ kesildi',
    warn_net_exception: 'Ağ sorunu',
    warn_request_timeout: 'Zaman aşımı',
    trending: 'Trend',
    select_coin: 'Token seç',
    send: 'Gönder',
    history: 'Geçmiş',
    network: 'Ağ',
    address: 'Adres',
    max: 'Maks',
    sent_successfully: 'Gönderildi',
    withdraw_success_tip: 'Token’lar %1$s’e yollandı',
    market: 'Piyasa',
    overview: 'Genel',
    volume_24h: '24S Hacim',
    market_cap: 'Piyasa Değeri',
    buy_tax: 'Alış vergisi',
    sell_tax: 'Satış vergisi',
    lock_liquidity: 'Likidite kilitle',
    contract_open_source: 'Açık kaynak',
    honeypot: 'Honeypot',
    blacklist: 'Kara liste',
    proxy_contract: 'Proxy sözleşme',
    potentially_scam: 'Muhtemel dolandırıcılık',
    mintable: 'Basanabilir',
    slippage_modifiable: 'Slippage ayarlanabilir',
    contract_renounced: 'Sözleşme devredildi',
    dex_token_name: 'DEX Adı: %1$s',
    pool: 'Havuz',
    pool_address: 'Havuz: %1$s',
    liquidity: 'Likidite',
    fdv: 'FDV',
    txs_24h: '24S İşlem',
    total_supply: 'Toplam arz',
    holders: 'Tutucular',
    pool_created: 'Havuz oluşturuldu',
    pooled_placeholder: 'Havuzda %1$s',
    top_ten: 'En İyi 10',
    privacy_term: 'Gizlilik &amp; Şartlar',
    input_the_address: 'Adres gir',
    sending: 'Gönderiliyor…',
    amount_to_address: '%1$s %2$s -&gt; \n %3$s',
    sent_exclamation_mark: 'Gönder!',
    token_were_successfully_sent_to_address:
      '%1$s %2$s \n %3$s’e başarıyla yollandı',
    view_transaction: 'İşlemi gör',
    sending_was_canceled_by_user: 'Gönderim iptal',
    sending_was_rejected: 'Gönderim reddedildi',
    send_failed: 'Gönderilemedi',
    funds: 'Fonlar',
    transaction_failed: 'İşlem başarısız, tekrar dene',
    one_day: '1 Gün',
    holdings: 'Varlıklar',
    order_history: 'Emir geçmişi',
    txid: 'TXID',
    total_value: 'Toplam değer',
    current_price: 'Güncel fiyat',
    unealized_profits: 'Gerçekleşmemiş kar',
    total_cost: 'Alındı',
    average_cost_price: 'Ort. maliyet',
    realized_profits: 'Gerçekleşen kar',
    slippage: 'Slippage',
    confirming: 'Onaylanıyor…',
    completing: 'Tamamlanıyor…',
    cancelling: 'İptal Ediliyor',
    expired: 'Süresi Doldu',
    created: 'Oluşturuldu',
    pending: 'Beklemede',
    initial: 'Başlangıç',
    purchase: 'Satın al',
    filled_cap: 'Doldurulan limit',
    get: 'Al',
    reset_password: 'Şifre sıfırla',
    new_password: 'Yeni şifre',
    confirm_password: 'Şifre onayla',
    verification_code: 'Doğrulama kodu',
    find_pwd_subtitle: 'E-posta',
    reset_pwd_successfully: 'Şifre sıfırlandı',
    account_unregisted: 'Hesap kayıtlı değil',
    confirmed: 'Onaylandı',
    cancelled: 'İptal',
    mkt_cap: 'MKT Değeri',
    system_tip: 'Sistem mesajı',
    swap_tip:
      '%1$s bakiyen %2$s altında; yetersiz gas ücreti işlem hatasına neden olabilir.',
    continue_trading: 'Yine de devam',
    go_to_top_up: 'SOL ekle',
    completed: 'Tamamlandı',
    slippage_setting_tip:
      'Not: Tanımladığınız slippage toleransı, kabul edebileceğiniz en yüksek sınırdır. Sistem bu sınır içinde optimum şekilde ayarlanır ve gerçek slippage genellikle çok daha düşük gerçekleşir.',
    assets: 'Varlıklar',
    hide_small_assets: 'Küçük varlıkları gizle',
    login_to_memeshot: "%1$s\'ye giriş yap",
    create_memeshot_account: '%1$s Hesabı Oluştur',
    already_have_an_account: 'Zaten bir hesabınız var mı?',
    limit_trade: 'Limit',
    market_trade: 'Piyasa',
    limit_order: 'Limit',
    buy_when_drop_to_preset: 'Satış Oranı',
    sell_when_rise_to_preset: 'Alış Oranı',
    validity_period: 'Vade Sonu',
    permanent: 'Asla',
    ten_minutes: '10 Dakika',
    one_hour: '1 Saat',
    three_days: '3 Gün',
    thirty_days: '30 Gün',
    set_validity_period: 'Vade Sonu',
    preset_buy_drop_percentage: 'Satış Oranı',
    preset_sell_rise_percentage: 'Alış Oranı',
    order_failed: 'Sipariş Gerçekleşmedi',
    order_created: 'Emir İptal Edildi',
    total_profit: 'Toplam Kar',
    preset_trade_price_with_type: '%1$s Tetik Fiyatı',
    month: 'ay',
    purchase_price_sol: '%1$s SOL Yatır',
    volume: 'Miktar',
    cancel_limit_order: 'Limit emrini iptal et',
    transaction_success: 'Tamamlandı',
    payment: 'Öde',
    obtain: 'Al',
    payment_address: 'Adres',
    order_time: 'Emir Zamanı',
    expiry_time: 'Sonlanma Zamanı',
    type: 'Tür',
    network_fee: 'Ağ Ücreti',
    order_placing_time: 'Listeleme Zamanı',
    transaction_price: 'Gerçekleşen Fiyat',
    cancel_order_successfully: 'Emir başarıyla iptal edildi',
    view_in_solscan: "Solscan'de görüntüle",
    status: 'Durum',
    order_price: 'Emir Fiyatı',
    trigger_price: 'Tetikleyici Fiyat',
    get_price_sol: '%1$s SOL Al',
    day: 'g',
    hour: 'sa',
    minute: 'dk',
    second: 'sn',
    tip_limit_trade_min_amount: 'Limit emir işlem tutarı en az 5 dolar olmalıdır',
    amount_mkt_cap: '%1$s Piyasa Değeri',
    never: 'Asla',
    login_expired: 'Oturum bitti. Tekrar giriş yapın',
    hot: 'Trend',
    selected: 'Seçkin',
    favorite: 'Favoriler',
    more: 'Daha fazla',
    searchBtn: 'Ara',
    searchAddress: 'Sözleşme Ara',
    emailInput: 'Lütfen e-posta girin',
    passwordInput: 'Lütfen şifre girin',
    please_complete_verification: 'Lütfen doğrulamayı tamamlayın',
    tradeHash: 'İşlem Hash’i',
    noMore: 'Ek veri bulunmamaktadır',
    spend: 'Yatır',
    slippageWarning1: 'Lütfen geçerli bir değer giriniz',
    slippageWarning2: "Slippage %100'den az olmalı",
    futures: 'Token',
    no_more_prompts: 'Bu bildirimi bir daha gösterme',
    promptTips1:
      'İşlem başarısını garanti altına almak için, işlem sürecini kolaylaştırmak üzere cüzdanınızda otomatik olarak %1$s %2$s tutarında ağ ücreti ayrılmıştır.',
    promptTips2:
      'İşlem başarısızlıkları yetersiz ağ ücreti, düşük slipaj toleransı veya ağ yoğunluğundan kaynaklanabilir. Bu parametreleri uygun şekilde ayarlayarak başarılı işlem olasılığını artırabilirsiniz.',
    slippage_tip:
      'Slipaj, piyasadaki bir işlemin öngörülen yürütme fiyatı ile gerçek yürütme fiyatı arasındaki farktır. Fiyat dalgalanmaları belirlenen slipaj tolerans eşiğini aştığında, işlem otomatik olarak iptal edilecek ve çıkarlarınızı koruyacaktır, ancak denenen yürütme için ağ ücretleri yine de tahsil edilecektir.',
    gas_fee_tip:
      'Gas ücreti, blok zinciri ağında işlemlerin yürütülmesi için gereken hesaplama maliyetini temsil eder. Bu ücret, işlemleri işleyen doğrulayıcıları tazmin eder ve işlem karmaşıklığına göre değişir.',

    filter_text: 'Filtrele',
    sort_text: 'Sırala',
    application_text: 'Uygula',
    time_slot_text: 'Zaman Aralığı',
    price_changes: 'Fiyat Değişimi',
    privacy_and_Term: 'Gizlilik ve Şartlar',
    systemTips: '** bakiyesi düşük',
    inputCount: 'Tutarı Girin',
    toDeposit: '** yatır',
    continueTrade: 'İptal',
    reason: 'Sebep',
    "insufficientBalance": "Bakiye yetersiz",
    inputTips: "Yetersiz gas ücreti işlemi bozabilir, yine de gas alınır. Cüzdanda en az ** && bulundurun.",
    orderFail: 'Emir Başarısız',
    errorLoginExpired: 'Oturum bitti. Tekrar giriş yapın',
    retry: 'Yeniden dene'
  },
  ko_KR: {
    twitter: '트위터',
    facebook: '페이스북',
    telegram: '텔레그램',
    whatsapp: '왓츠앱',
    google: '구글',
    perform_app_not_installed: '%1$s 앱이 설치되지 않았습니다',
    about_us: '회사 소개',
    no_data_available: '데이터 없음',
    register: '회원가입',
    close: '닫기',
    phone_number_or_email: '이메일',
    password: '비밀번호',
    other_methods: '기타 방법',
    forgot_password: '비밀번호 재설정',
    login: '로그인',
    check_for_updates: '업데이트 확인',
    security_verification: '보안 인증',
    phone_verificate: '휴대폰 인증',
    email_verificate: '이메일 인증',
    google_verificate: '구글 인증',
    google_verification_code: '구글 인증코드',
    phone_verification_code: '휴대폰 인증코드',
    email_verification_code: '이메일 인증코드',
    login_tip_didSendCode: '인증 코드 전송됨',
    register_action_setPassword: '비밀번호 설정',
    register_tip_repeatPassword: '비밀번호 재입력',
    login_action_resetPassword: '비밀번호 재설정',
    toast_google_code_missing: '구글 인증코드 입력',
    toast_phone_code_missing: '휴대폰 인증코드 입력',
    toast_email_code_missing: '이메일 인증코드 입력',
    verification_methods_required: '모든 인증 수단을 완료하세요',
    id_card_number: '신분증 번호',
    input_national_id: '신분증 번호를 입력하세요',
    google_code: '구글 코드',
    next: '다음',
    settings: '설정',
    deposit: '입금',
    deposit_qr_code_tip: '이 주소는 %1$s 네트워크 자산만 입금 가능합니다',
    save_qr_code: 'QR 코드 저장',
    deposit_network: '네트워크',
    deposit_asset: '%1$s 입금',
    deposit_address: '주소',
    copy: '복사',
    how_to_deposit: '입금 방법?',
    language: '언어',
    search: '컨트랙트 검색',
    choose_country_or_area: '국가/지역:',
    country_saudi_arabia: '사우디아라비아',
    select_country_area: '거주 국가/지역',
    email: '이메일',
    default_area_saudi_arabia: '사우디아라비아 (+966)',
    default_country_code: '+966',
    referral_id_hint_optional: '초대 코드(선택)',
    referral_id_hint: '초대 코드',
    settings_kline_color: '상승/하락 색상',
    invite_friend: '추천',
    version: '버전',
    logout: '로그아웃',
    settings_global_kline_color: '상승은 녹색, 하락은 빨간색',
    settings_china_kline_color: '상승은 빨간색, 하락은 녹색',
    home: '홈',
    markets: '마켓',
    wallets: '자산',
    trades: '거래',
    save_success: '저장됨',
    save_fail: '저장 실패',
    storage_permission_warning: '저장 권한 없음',
    select_currency: '토큰 선택',
    copy_address_success: '주소 복사됨',
    loading: '로딩 중…',
    logging_in: '로그인 중…',
    login_successful: '로그인 완료',
    email_format_error: '유효하지 않은 이메일',
    phone_number_format_error: '유효하지 않은 휴대폰 번호',
    confirm_button: '확인',
    login_action_fogetpwdSafety: '보안 인증',
    google_authentication: '구글 인증',
    phone_authentication: '휴대폰 인증',
    amount_greater_than_fee: '금액은 수수료보다 커야 합니다',
    withdrawal_minimum: '최소 출금액',
    withdrawal_address_invalid: '유효하지 않은 주소',
    scan_qr_code_tip: 'QR 코드에 맞추세요',
    scan_invalid_content: '유효한 콘텐츠 없음',
    insufficient_balance: '잔액 부족',
    buy: '매수',
    sell: '매도',
    copy_successful: '복사됨',
    paste: '붙여넣기',
    safety_verification: '보안 검증',
    get_verification_code: '코드 받기',
    certified: '인증됨',
    verification_failed_retry: '인증 실패, 다시 시도하세요',
    password_rules:
      '비밀번호는 8자 이상이며 소문자, 대문자, 숫자, 특수문자 중 3가지 이상을 포함해야 합니다',
    password_length_more_than_20: '최대 20자',
    password_length_less_than_8: '최소 8자',
    password_requirements:
      '비밀번호는 8자 이상이며 소문자, 대문자, 숫자, 특수문자 중 3가지 이상을 포함해야 합니다',
    password_meets_requirements: '비밀번호 요건 충족',
    account_registered: '이미 계정이 있습니다; 로그인하세요',
    register_successfully: '회원가입 완료',
    network_disconnected: '네트워크 연결 끊김',
    network_abnormal: '네트워크 이상 상태',
    request_timeout: '요청 시간 초과',
    system_error_retry: '시스템 오류 발생, 다시 시도',
    register_agreement_privacy_desc: '개인정보 처리방침에 동의합니다',
    cancel: '취소',
    submit: '제출',
    reset: '초기화',
    verification_code_hint: '인증 코드를 입력하세요',
    resend: '재전송',
    binding_phone: '휴대폰 연결',
    binding_email: '이메일 연결',
    login_pass: '로그인 비밀번호',
    asset_pass: '자산 비밀번호',
    new_input_nickname: '닉네임(최대 10자) 입력',
    success: '성공',
    failed: '실패',
    spent: '지출됨',
    received: '수령됨',
    receive: '받기',
    rejected: '거부됨',
    please_enter_correct_information: '올바른 정보를 입력하세요',
    amount: '금액',
    available: '사용 가능',
    exceeds_available_balance: '사용 가능 잔액 초과',
    min_withdraw_amount: '최소 출금액: %1$s %2$s (수수료 포함)',
    max_withdraw_amount: '코인별 최대 출금액: %1$s %2$s',
    get_amount: '수령 금액: %1$s %2$s',
    handling_fee_amount: '수수료: %1$s %2$s',
    fastest: '우선순위',
    fast: '빠르게',
    normal: '일반',
    last_price: '가격',
    price_limit_24h: '24시간 변동률%',
    name: '이름',
    time: '시간',
    custom: '사용자 지정',
    gas_fee: '가스 수수료',
    state: '상태',
    price: '가격',
    ok: '확인',
    not_certified: '권한 없음',
    verified: '인증됨',
    account: '계정',
    under_review: '검토 중',
    customSetting_action_global: '상승: 초록 / 하락: 빨강',
    customSetting_action_china: '빨강 / 하락: 초록',
    common_tip_logoutDesc: '현재 계정에서 로그아웃하시겠습니까?',
    userinfo_tip_inputPhone: '유효하지 않은 전화번호',
    toast_email_error: '유효하지 않은 이메일',
    register_pwd_rule_tip:
      '비밀번호는 최소 8자 이상이며 소문자, 대문자, 숫자, 특수문자 중 3가지 이상 포함해야 합니다',
    pwd_rule_more_than_length: '최대 20자',
    pwd_rule_less_than_length: '최소 8자',
    pwd_rule_contain_char_number:
      '비밀번호는 최소 8자 이상이며 소문자, 대문자, 숫자, 특수문자 중 3가지 이상 포함해야 합니다',
    pwd_rule_conform_require: '비밀번호 조건 충족',
    confirm: '확인',
    choose_withdraw_network: '네트워크 선택',
    withdraw_select_network_tip:
      '참고: 출금 및 입금 네트워크가 일치하고 지원되는지 확인하세요. 지원되지 않으면 자산 손실 가능.',
    withdraw_select_network_tip2: '네트워크 정보 확인',
    input_amount_more_than_fee_tip: '금액은 거래 수수료를 초과해야 합니다',
    subtitle_withdraw_min: '출금 기준',
    toast_no_withdraw_address: '유효하지 않은 주소',
    copy_success: '복사됨',
    get_code: '코드 받기',
    system_error_please_try_again: '시스템 오류, 다시 시도',
    warn_net_disconnect: '네트워크 연결 끊김',
    warn_net_exception: '네트워크 이상 상태',
    warn_request_timeout: '요청 시간 초과',
    trending: '트렌딩',
    select_coin: '토큰 선택',
    send: '전송',
    history: '내역',
    network: '네트워크',
    address: '주소',
    max: '최대',
    sent_successfully: '전송 성공',
    withdraw_success_tip: '토큰이 %1$s에게 성공적으로 전송되었습니다',
    market: '마켓',
    overview: '개요',
    volume_24h: '24시간 거래량',
    market_cap: '시가총액',
    buy_tax: '매수 세율',
    sell_tax: '매도 세율',
    lock_liquidity: '유동성 잠금',
    contract_open_source: '오픈소스',
    honeypot: '허니팟',
    blacklist: '블랙리스트',
    proxy_contract: '프록시 컨트랙트',
    potentially_scam: '잠재적 사기',
    mintable: '추가 발행 가능',
    slippage_modifiable: '슬리피지 조정 가능',
    contract_renounced: '컨트랙트 포기',
    dex_token_name: 'DEX 이름: %1$s',
    pool: '풀',
    pool_address: '풀: %1$s',
    liquidity: '유동성',
    fdv: 'FDV',
    txs_24h: '24시간 거래 수',
    total_supply: '총 발행량',
    holders: '홀더 수',
    pool_created: '풀 생성됨',
    pooled_placeholder: '풀 내 %1$s',
    top_ten: '상위 10',
    privacy_term: '개인정보 및 약관',
    input_the_address: '주소를 입력하세요 (예: "0x...")',
    sending: '전송 중…',
    amount_to_address: '%1$s %2$s를 \n %3$s로 전송',
    sent_exclamation_mark: '전송!',
    token_were_successfully_sent_to_address:
      '%1$s %2$s가 \n %3$s로 성공적으로 전송되었습니다',
    view_transaction: '거래내역 보기',
    sending_was_canceled_by_user: '전송이 사용자에 의해 취소됨',
    sending_was_rejected: '전송 거절됨',
    send_failed: '전송 실패',
    funds: '자금',
    transaction_failed: '거래 실패, 다시 시도',
    one_day: '1일',
    holdings: '보유량',
    order_history: '주문 내역',
    txid: '거래 ID',
    total_value: '총 가치',
    current_price: '현재 가격',
    unealized_profits: '미실현 이익',
    total_cost: '매수',
    average_cost_price: '평균 매수가',
    realized_profits: '실현 이익',
    slippage: '슬리피지',
    confirming: '확인 중…',
    completing: '완료 중…',
    cancelling: '취소 진행 중',
    expired: '만료됨',
    created: '생성됨',
    pending: '대기 중',
    initial: '초기 상태',
    purchase: '구매',
    filled_cap: '할당량 충족',
    get: '받기',
    reset_password: '비밀번호 재설정',
    new_password: '새 비밀번호',
    confirm_password: '비밀번호 확인',
    verification_code: '인증 코드',
    find_pwd_subtitle: '이메일',
    reset_pwd_successfully: '비밀번호 재설정 완료',
    account_unregisted: '계정이 등록되지 않음',
    confirmed: '확인됨',
    cancelled: '취소됨',
    mkt_cap: '시가총액(MKT CAP)',
    system_tip: '시스템 메시지',
    swap_tip:
      '%1$s 잔액이 %2$s 이하입니다. 가스 수수료 부족으로 거래가 실패할 수 있습니다.',
    continue_trading: '그래도 진행',
    go_to_top_up: 'SOL 추가',
    completed: '완료됨',
    slippage_setting_tip:
      '참고: 설정한 슬리피지는 허용 가능한 상한입니다. 이 범위 내에서 시스템은 슬리피지를 자동으로 최소화하여 실제 반영 값은 대체로 훨씬 낮게 유지됩니다.',
    assets: '자산',
    hide_small_assets: '소액 자산 숨기기',
    login_to_memeshot: '%1$s에 로그인',
    create_memeshot_account: '%1$s 계정 만들기',
    already_have_an_account: '이미 계정이 있으신가요?',
    limit_trade: '제한',
    market_trade: '마켓',
    limit_order: '제한',
    buy_when_drop_to_preset: '해당 시세로 판매하기',
    sell_when_rise_to_preset: '해당 시세로 구매하기',
    validity_period: '만료됨',
    permanent: '해당 없음',
    ten_minutes: '10분 만료',
    one_hour: '1시간 만료',
    three_days: '3일 만료',
    thirty_days: '30일 만료',
    set_validity_period: '기간 설정',
    preset_buy_drop_percentage: '해당 시세로 판매하기',
    preset_sell_rise_percentage: '해당 시세로 구매하기',
    order_failed: '주문 실패',
    order_created: '주문 생성 완료',
    total_profit: '총 수익',
    preset_trade_price_with_type: '%1$s 트리거 가격',
    month: '월',
    purchase_price_sol: '%1$s SOL 투입',
    volume: '수량',
    cancel_limit_order: '제한가 주문 취소',
    transaction_success: '완료',
    payment: '결제',
    obtain: '획득',
    payment_address: '주소',
    order_time: '날짜',
    expiry_time: '만료 시간',
    type: '유형',
    network_fee: '네트워크 수수료',
    order_placing_time: '등록 시간',
    transaction_price: '체결 가격',
    cancel_order_successfully: '주문이 성공적으로 취소되었습니다',
    view_in_solscan: 'Solscan에서 보기',
    status: '상태',
    order_price: '주문 가격',
    trigger_price: '트리거 가격',
    get_price_sol: '%1$s SOL 획득',
    day: '일',
    hour: '시간',
    minute: '분',
    second: '초',
    tip_limit_trade_min_amount: '지정가 주문 거래 금액은 최소 $5 이상이어야 합니다',
    amount_mkt_cap: '%1$s 시가총액',
    never: '해당 없음',
    login_expired: '로그인 만료. 다시 로그인하세요',
    hot: '트렌딩',
    selected: '엄선',
    favorite: '관찰 목록',
    more: '더 보기',
    searchBtn: '검색',
    searchAddress: '스마트 계약 검색',
    emailInput: '이메일을 입력하세요',
    passwordInput: '비밀번호를 입력하세요',
    please_complete_verification: '인증을 완료해주세요',
    tradeHash: '거래 해시',
    noMore: '추가 데이터가 없습니다',
    spend: '투입',
    slippageWarning1: '유효한 값을 입력해주세요.',
    slippageWarning2: '슬리피지는 100% 미만이어야 합니다',
    futures: '토큰',
    no_more_prompts: '다시 표시하지 않음',
    promptTips1:
      '거래의 원활한 처리를 위해 %1$s %2$s가 네트워크 수수료로 자동 예약되었습니다.',
    promptTips2:
      '거래 실패는 네트워크 수수료 부족, 낮은 슬리피지 허용치, 또는 네트워크 혼잡으로 발생할 수 있습니다. 수수료와 슬리피지를 조정하여 거래 성공률을 높일 수 있습니다.',
    slippage_tip:
      '슬리피지는 거래 예상 가격과 실제 가격 간의 차이를 의미합니다. 설정된 허용 범위를 초과하면 거래가 자동으로 취소되며, 네트워크 수수료는 부과됩니다.',
    gas_fee_tip:
      '가스 수수료는 블록체인 네트워크에서 거래를 처리하는 데 필요한 연산 비용입니다. 거래의 복잡성에 비례해 컴퓨팅 리소스를 소비하며, 검증자들은 이를 할당하고 가스 수수료로 보상을 받습니다.',
    filter_text: '필터',
    sort_text: '정렬',
    application_text: '적용',
    time_slot_text: '기간',
    price_changes: '가격 변동',
    privacy_and_Term: '개인정보 및 약관',
    systemTips: '** 잔액 부족',
    inputCount: '금액 입력',
    toDeposit: '** 입금',
    continueTrade: '그래도 진행',
    reason: '원인',
    "insufficientBalance": "잔액이 부족합니다",
    inputTips: "가스 수수료 부족으로 트랜잭션 실패 가능성이 있으며, 실패 시에도 가스 수수료가 청구됩니다. 지갑 잔액이 최소 ** && 이상인지 확인하십시오.",
    orderFail: '주문 실패',
    errorLoginExpired: '현재 로그인이 만료되었습니다. 다시 시도해 주세요',
    retry: '다시 시도'
  },
}
